import { render, staticRenderFns } from "./powerStation.vue?vue&type=template&id=3a404f84&scoped=true&"
import script from "./powerStation.vue?vue&type=script&lang=js&"
export * from "./powerStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a404f84",
  null
  
)

export default component.exports